import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { CurrentBalanceBadgeProps } from "./CurrentBalanceBadge.types"

const icon = faIcon({ name: "receipt", style: "regular" })

export default function CurrentBalanceBadge(props: CurrentBalanceBadgeProps) {
    const { balance, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    // The badge is always shown — a missing balance renders as "$0.00".
    const formatted = formatCurrency(balance ?? 0)

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={`Current balance from open POs\n${formatted}`}>
            {formatted}
        </Badge>
    )
}
